import React from 'react'
import { useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'hooks/use-redux'
import { loadLibrary } from '@disco/state-management/actions/ExplorerActions'
import { getGroupBySlug } from '@disco/state-management/selectors/groups'

export default function GroupRedirect() {
  const { groupSlug } = useParams<{ groupSlug: string }>()
  const dispatch = useDispatch()
  const group = useSelector((state: any) =>
    getGroupBySlug(state, {
      slug: groupSlug,
    }),
  )

  React.useEffect(() => {
    if (group) {
      dispatch(loadLibrary(group))
    }
  }, [group, dispatch])

  return null
}
